import React, { useEffect, useState } from 'react';
import { Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Loader from '../../utils/loading/Loader';
import GetCookie from  '../../utils/GetCookie';

const AuthorizedLoginRoute = ({ element: Component, ...rest }) => {
  const [isAuthorized, setIsAuthorized] = useState(null);
  const accessToken = GetCookie('access_token');
  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const response = await axios.post('/pceapi/auth/iamuser/authorizationcheck', {}, {
          headers: {
            Authorization: accessToken,
          }
        });
        if (response.data.status === 'Authorized') {
          setIsAuthorized(true);
        } else {
          setIsAuthorized(false);
        }
      } catch (error) {
        setIsAuthorized(false);
      }
    };

    checkAuthorization();
  }, []);

  if (isAuthorized === null) {
    return <div><Loader/></div>;
  }

  return (
    isAuthorized ? <Navigate to="/dashboard" /> : <Component {...rest} />
  );
};

export default AuthorizedLoginRoute;